var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('icone-simples-redondo-com-label',{attrs:{"label-botao":"P","texto":_vm.message,"cor-background":"orange"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }